export const buildFilesFormData = (files, type) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });
  formData.append("type", type);
  return formData;
};
